// @flow

export * from './my-rgs-user-juridical-person';
export * from './my-rgs-user-person';
